import React from "react";
import { Box, Hidden } from "@origin-digital/ods-core";
import { Skeleton } from "@origin-digital/ods-lab";
import styled from "styled-components";

interface CategoryImageProps {
  name?: string;
  imageUrl: string;
  isLoading?: boolean;
}

const StyledCategoryImage = styled.img`
  margin-bottom: -68px; // Position at the bottom for the overlap effect
  width: 248px;
  height: 248px;
  object-fit: cover;
  align-self: flex-end;
  ${({ theme }) => theme.breakpoints.down("md")} {
    width: 128px;
    height: 128px;
  }
`;

const StyledBox = styled(Box)`
  ${({ theme }) => theme.breakpoints.down("md")} {
    width: 128px;
    height: 128px;
    overflow: hidden;
  }
`;

const StyledSkeletonBox = styled(Box)`
  margin-bottom: -68px;
  ${({ theme }) => theme.breakpoints.down("md")} {
    width: 128px;
    height: 128px;
  }
`;

const DESKTOP_SIZE = 248;
const MOBILE_SIZE = 128;
const SKELETON_PROPS = {
  variant: "rounded" as const,
  backgroundColor: "dark" as const,
};

export const CategoryImage: React.FC<CategoryImageProps> = ({
  name,
  imageUrl,
  isLoading,
}) => (
  <StyledBox>
    {isLoading ? (
      <StyledSkeletonBox>
        <Hidden below="sm">
          <Skeleton
            {...SKELETON_PROPS}
            width={DESKTOP_SIZE}
            height={DESKTOP_SIZE}
          />
        </Hidden>
        <Hidden above="md">
          <Skeleton
            {...SKELETON_PROPS}
            width={MOBILE_SIZE}
            height={MOBILE_SIZE}
          />
        </Hidden>
      </StyledSkeletonBox>
    ) : imageUrl ? (
      <StyledCategoryImage src={imageUrl} alt={""} />
    ) : null}
  </StyledBox>
);
